import { Router } from './routes/router';

export function App() {
	return <Router />;
}
